// CZ → DE překlad pro tc_system_configs (system_type / package_unit).
// DB drží jeden zdroj pravdy v CZ (sdíleno s CZ partnery). UI překládá pro DE
// portál; value zůstává CZ pro round-trip do DB.

const SYSTEM_TYPE_DE: Record<string, string> = {
  "1 přímý + 1 směšovaný": "1 direkt + 1 gemischt",
  "1 přímý okruh": "1 direkter Heizkreis",
  "2 směšované okruhy": "2 gemischte Heizkreise",
  Bazén: "Pool",
  "Bivalent / hybrid": "Bivalent / Hybrid",
  "Buffer + 1 nesměšovaný": "Pufferspeicher + 1 ungemischt",
  "Jen vytápění": "Nur Heizung",
  "Solar / bivalentní TUV": "Solar / bivalenter Warmwasser",
  "Vytápění + TUV": "Heizung + Warmwasser",
  "Vytápění + TUV + chlazení": "Heizung + Warmwasser + Kühlung",
  "Vytápění + TUV + chlazení + buffer": "Heizung + Warmwasser + Kühlung + Pufferspeicher",
  "Vytápění + TUV + chlazení + buffer + více okruhů":
    "Heizung + Warmwasser + Kühlung + Pufferspeicher + mehrere Kreise",
};

const PACKAGE_UNIT_DE: Record<string, string> = {
  "B + plynový kotel": "B + Gaskessel",
  "Bez integrovaného TUV": "Ohne integriertes Warmwasser",
  "E + buffer + bazén": "E + Pufferspeicher + Pool",
  "E + PNR + krbová kamna": "E + PNR + Kaminofen",
  "Externí buffer Vitocell 100-E / 140-E": "Externer Pufferspeicher Vitocell 100-E / 140-E",
  "HM Trend + externí TUV": "HM Trend + externes Warmwasser",
  "HSBB 180 Plus, integrovaný TUV": "HSBB 180 Plus, integriertes Warmwasser",
  "HSBC 180 Plus, integrovaný TUV + buffer":
    "HSBC 180 Plus, integriertes Warmwasser + Pufferspeicher",
  "HSBC 200, integrovaný TUV + buffer": "HSBC 200, integriertes Warmwasser + Pufferspeicher",
  "HSBC 300 cool, integrovaný TUV + buffer":
    "HSBC 300 cool, integriertes Warmwasser + Pufferspeicher",
  "Integrovaný TUV": "Integriertes Warmwasser",
  "Modul výměníku tepla": "Wärmetauschermodul",
  "Solar / bivalentní": "Solar / bivalent",
};

export function translateSystemType(value: string): string {
  return SYSTEM_TYPE_DE[value] || value;
}

export function translatePackageUnit(value: string): string {
  return PACKAGE_UNIT_DE[value] || value;
}
